module.exports = __webpack_public_path__ + "static/img/9.49084521.jpg";